// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"184":"cbf60a63","205":"9625eb3a"}[chunkId] + ".chunk.js";
};